import { Injectable } from '@angular/core';
import { ColumnFilter } from './gfo.service';
import { BehaviorSubject } from 'rxjs';
import { CommonModalService } from './common-modal.service';

export interface AttrFilter {
	filter: ColumnFilter;
	isAutoCheckDomain?: boolean;
	domainFilters?: ColumnFilter[];
}
export interface AttrFilterColumn {
	name: string;
	prop: string;
}

@Injectable({
  providedIn: 'root'
})
export class AttributeFilterService {

	attrFilters: BehaviorSubject<{
		filters: AttrFilter[],
		source?: 'labels' | 'popup',
		skipGetData?: boolean;
	}> = new BehaviorSubject({
		filters: []
	});
	attrFilterColumns: BehaviorSubject<AttrFilterColumn[]> = new BehaviorSubject([]);
	constructor(
		private modalService: CommonModalService
	) { }

	clearAttrFilters(skipGetData?: boolean) {
		this.attrFilters.next({
			filters: [],
			skipGetData
		});
	}
	openAttrFilter(filterComponent) {
		this.modalService.openModalWindow(filterComponent, {
			height: '500px',
			width: '440px'
		})
	}
}
